import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';

import Header from './Header'
import LeftContent from './LeftContent'
import Header2 from './Header2'
import './DashbordEtudiant.css'
function DashbordEtudiant() {
  let { uid } = useParams();
 /* console.log(uid , 'from DashbordEtudiant')*/

  return (
   <>
   <Header/>
   <div style={{backgroundColor:'orange' , height:'8px'}}></div>
   <Header2/>
   <div className='leftcontent'>
   <LeftContent uid={uid} />
   </div>
    
    
  

   </>
  )
}

export default DashbordEtudiant